// src/i18n/index.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fa',
    supportedLngs: ['fa', 'en', 'ar'], // ← ar اضافه شد
    interpolation: { escapeValue: false },
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    ns: ['common', 'forms', 'crm', 'login'], // ← یه namespace جدا برای لاگین
    defaultNS: 'common',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'appLanguage',
    },
  });

let isLocked = false;

export const setLanguageLock = (locked: boolean) => {
  isLocked = locked;
};

// این تابع رو فقط خودمون از UI صدا می‌زنیم — متد اصلی i18n دست‌نخورده می‌مونه
export const changeLanguageSafe = (lng: string) => {
  console.log('changeLanguageSafe called with:', lng, 'isLocked:', isLocked);
  if (isLocked) {
    console.warn('Language is locked. Log out to change it.');
    return Promise.resolve();
  }
  return i18n.changeLanguage(lng);
};

export default i18n;